import { User } from "../model/user";

export interface UtilisateurDto {
  id: string;
  email: string;
  faseEtablissement: number;
  droitsAcces: string[];
};

export const UtilisateurDtoMapper = {
  toDomain: (dto: UtilisateurDto): User => {
    return {
      id: dto.id,
      email: dto.email,
      establishmentFase: dto.faseEtablissement,
      accessRights: convertAccessRightsToDomain(dto.droitsAcces),
    } as User;
  },
  toDto: (data: User): UtilisateurDto => {
    return {
      id: data.id,
      email: data.email,
      faseEtablissement: data.establishmentFase,
      droitsAcces: convertAccessRightsToDto(data.accessRights),
    } as UtilisateurDto;
  }
};

function convertAccessRightsToDto(accessRights: string[]): string[] {
  return accessRights.map((right: string) => {
    if (right === 'CONSULT') {
      return 'CONSULTER';
    }
    if (right === 'EDIT') {
      return 'EDITER';
    }
    return '';
  }).filter((right: string) => right !== '');
}

function convertAccessRightsToDomain(accessRights: string[]): string[] {
  return accessRights.map((right: string) => {
    if (right === 'CONSULTER') {
      return 'CONSULT';
    }
    if (right === 'EDITER') {
      return 'EDIT';
    }
    return '';
  }).filter((right: string) => right !== '');
}
